import { ValuableModel } from '../../models'

export class SchemaDynamicModel extends ValuableModel {}

declare global {
  export interface RehajeTypedModels {
    'Schema.Dynamic': SchemaDynamicModel
  }
}
